<template>
  <div class="language-switcher inline-flex items-center rounded-lg border border-ink/10 p-0.5">
    <button
      @click="changeLanguage('en')"
      :class="currentLanguage === 'en' ? 'bg-kettelsen text-white shadow-sm' : 'text-ink/60 hover:text-ink'"
      class="px-2.5 py-1 rounded-md text-xs font-bold tracking-wide transition-all duration-200 focus:outline-none"
    >
      EN
    </button>
    <button
      @click="changeLanguage('es')"
      :class="currentLanguage === 'es' ? 'bg-kettelsen text-white shadow-sm' : 'text-ink/60 hover:text-ink'"
      class="px-2.5 py-1 rounded-md text-xs font-bold tracking-wide transition-all duration-200 focus:outline-none"
    >
      ES
    </button>
  </div>
</template>

<script>
import { useI18n } from 'vue-i18n'

export default {
  name: 'LanguageSwitcher',
  setup() {
    const { locale } = useI18n()

    return {
      currentLanguage: locale,
      changeLanguage(lang) {
        locale.value = lang
        if (typeof document !== 'undefined') {
          document.documentElement.lang = lang
        }
      }
    }
  }
}
</script>
